// extracted by mini-css-extract-plugin
export default {"card":"E5-z"};